import { redirect } from "react-router-dom";


const RedirectToDashBoard = async () => {

  return redirect("/users")
};

export default RedirectToDashBoard;